import TransactionDetailsTelco from "../../../entities/checkout/transaction/TransactionDetailsTelco";
import { ITransactionDetailsTelco } from "../../../entities/checkout/transaction/types";
import { IManhattanFactory } from "../../manhattan/types";
import { TransactionDetailsOrderFactory } from "./TransactionDetailsOrderFactory";

export const TransactionDetailsTelcoFactory: IManhattanFactory = class TransactionDetailsFactory {

  static create(transactionDetails: ITransactionDetailsTelco) {
    return new TransactionDetailsTelco(
      transactionDetails.general,
      TransactionDetailsOrderFactory.create(transactionDetails.order),
      transactionDetails.customer,
      transactionDetails.addresses,
      transactionDetails.deliveryDetails,
      transactionDetails.transaction,
      transactionDetails.applicableBenefits,
    );
  }

};
